import { Header as BronsonReactHeader } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { chooseVwBrand } from '../../../../config';

const HeaderContainer: React.FC = () => {
  const brand = process.env.REACT_APP_BRAND;

  const constructAlt = () => {
    switch (process.env.REACT_APP_BRAND) {
      case 'audi':
        return 'Audi logo';
      case 'vw':
      case 'vw6':
      case 'vwn':
        return 'Volkswagen logo';
      case 'vwfs':
      case 'bluelabel':
        return 'Bluelabel logo';
      case 'seat':
        return 'SEAT logo';
      case 'skoda':
        return 'Škoda logo';
      case 'cupra':
        return 'CUPRA logo';
      default:
        return 'Logo';
    }
  };

  const getBrand = () => {
    return brand?.includes('vw') ? chooseVwBrand(brand) : brand;
  };

  const getBrandLogoName = () => {
    return brand === 'vwn' ? 'logo-commercial-vehicle-de' : 'logo';
  };

  return (
    <BronsonReactHeader
      logo={
        <span className={`c-logo ${brand === 'vwn' ? 'c-logo--custom c-logo--vwn-logo' : ''}`}>
          <img
            src={`https://cdn.bronson.vwfs.io/${getBrand()}/v/25.1.0/img/${getBrandLogoName()}.svg`}
            alt={constructAlt()}
            className="c-logo__image"
          />
        </span>
      }
    />
  );
};

export default HeaderContainer;
